export default __webpack_public_path__ + "assets/images/8e619bb8f0824c360f2e6ff0724c39e6.webp";